import { useTranslation } from 'react-i18next';
import NodeContent from '../NodeContent';

function EndNode() {
  const { t } = useTranslation(['icp-form-renderer']);

  return (
    <div key="end-node" className="icp-workflow-node end-node">
      <NodeContent className="end-node-content" id={-1} disableDelete={true}>
        {t('workflow.end.content')}
      </NodeContent>
    </div>
  );
}

export default EndNode;
